import axios from 'axios';

class API {

    static async getAgentSummary(selectedTenant, accessToken, agentName, companyName) {
        try {

            const response = await axios.get('/api/agent-summary', {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'x-tenant': selectedTenant,
                },
                params: {
                    page: 1,
                    pageSize: 1000,
                    agentName,
                    companyName,
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data: ', error);
            throw error;
        }
    }
}

export default API;
